import { TenantContextService } from '../services/tenant-context.service';

let _ctx: TenantContextService | null = null;

/** Called once at app bootstrap so the free function below can reach the service. */
export function registerTenantContext(ctx: TenantContextService): void {
  _ctx = ctx;
}

/** Prefix any storage key with the active tenant UUID for tenant-scoped persistence. */
export function tenantKey(key: string): string {
  const uuid = _ctx?.tenantUuid() ?? null;
  return uuid ? `t${uuid}:${key}` : key;
}
